import { useEffect } from 'react';
import { usePathname } from 'expo-router';

import {
  usePostLoginRedirectHref,
  useSendClearPostLoginRedirectHref,
} from '../../../context/AuthMachine';
import { useRedirectAfterAuthStateChange } from '../../../navigation';

// ─────────────────────────────────────────────────────────────────────────────

export const usePostLoginRedirect = () => {
  const postLoginRedirectHref = usePostLoginRedirectHref();
  const sendClearPostLoginRedirectHref = useSendClearPostLoginRedirectHref();
  const redirectAfterAuthStateChange = useRedirectAfterAuthStateChange();
  const pathname = usePathname();

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(() => {
    if (!postLoginRedirectHref) return;

    if (postLoginRedirectHref !== pathname) {
      redirectAfterAuthStateChange(postLoginRedirectHref);
    }

    sendClearPostLoginRedirectHref();
  }, [
    pathname,
    postLoginRedirectHref,
    redirectAfterAuthStateChange,
    sendClearPostLoginRedirectHref,
  ]);
};
